import { jsx, jsxs } from "react/jsx-runtime";
import { c } from "react-compiler-runtime";
import { useState } from "react";
import { VariablesEditor } from "../variables-editor.js";
import { RequestHeadersEditor } from "../request-headers-editor.js";
import { SegmentedControl } from "../segmented-control/index.js";
import { useEditorState } from "../../utility/hooks.js";
/* empty css          */
import { tryParseJSONC } from "../../utility/jsonc.js";
const VAR_TAB_OPTIONS = [{
  value: "variables",
  label: "Variables"
}, {
  value: "headers",
  label: "Headers"
}];
function computeVariablesHint(value) {
  if (!value.trim()) {
    return null;
  }
  try {
    const parsed = tryParseJSONC(value);
    const count = parsed ? Object.keys(parsed).length : 0;
    return `${count} var${count === 1 ? "" : "s"} · valid`;
  } catch {
    return "invalid JSON";
  }
}
function useVariablesHint() {
  const $ = c(2);
  const [value] = useEditorState("variable");
  let t0;
  if ($[0] !== value) {
    t0 = computeVariablesHint(value);
    $[0] = value;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  return t0;
}
const VarHeadersStrip = (t0) => {
  const $ = c(24);
  const {
    defaultTab: t1,
    headersEditorEnabled: t2,
    onEditVariables,
    onEditHeaders
  } = t0;
  const defaultTab = t1 === void 0 ? "variables" : t1;
  const headersEditorEnabled = t2 === void 0 ? true : t2;
  const [varTab, setVarTab] = useState(headersEditorEnabled ? defaultTab : "variables");
  const hint = useVariablesHint();
  const showHeaders = headersEditorEnabled && varTab === "headers";
  let t3;
  if ($[0] !== headersEditorEnabled) {
    t3 = headersEditorEnabled ? VAR_TAB_OPTIONS : VAR_TAB_OPTIONS.filter(_temp);
    $[0] = headersEditorEnabled;
    $[1] = t3;
  } else {
    t3 = $[1];
  }
  const options = t3;
  const t4 = showHeaders ? "headers" : "variables";
  let t5;
  if ($[2] !== options || $[3] !== t4) {
    t5 = /* @__PURE__ */ jsx(SegmentedControl, { value: t4, onChange: setVarTab, options, ariaLabel: "Editor tools" });
    $[2] = options;
    $[3] = t4;
    $[4] = t5;
  } else {
    t5 = $[4];
  }
  let t6;
  if ($[5] !== hint || $[6] !== showHeaders) {
    t6 = !showHeaders && hint !== null && /* @__PURE__ */ jsx("span", { className: "graphiql-var-hint", "aria-live": "polite", children: hint });
    $[5] = hint;
    $[6] = showHeaders;
    $[7] = t6;
  } else {
    t6 = $[7];
  }
  let t7;
  if ($[8] !== t5 || $[9] !== t6) {
    t7 = /* @__PURE__ */ jsxs("div", { className: "graphiql-var-headers-strip-bar", children: [
      t5,
      t6
    ] });
    $[8] = t5;
    $[9] = t6;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  const t8 = showHeaders ? "hidden" : "";
  let t9;
  if ($[11] !== onEditVariables || $[12] !== t8) {
    t9 = /* @__PURE__ */ jsx(VariablesEditor, { className: t8, onEdit: onEditVariables });
    $[11] = onEditVariables;
    $[12] = t8;
    $[13] = t9;
  } else {
    t9 = $[13];
  }
  let t10;
  if ($[14] !== headersEditorEnabled || $[15] !== onEditHeaders || $[16] !== showHeaders) {
    t10 = headersEditorEnabled && /* @__PURE__ */ jsx(RequestHeadersEditor, { className: showHeaders ? "" : "hidden", onEdit: onEditHeaders });
    $[14] = headersEditorEnabled;
    $[15] = onEditHeaders;
    $[16] = showHeaders;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t9) {
    t11 = /* @__PURE__ */ jsxs("div", { className: "graphiql-var-headers-strip-content", children: [
      t9,
      t10
    ] });
    $[18] = t10;
    $[19] = t9;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t7) {
    t12 = /* @__PURE__ */ jsxs("div", { className: "graphiql-var-headers-strip", children: [
      t7,
      t11
    ] });
    $[21] = t11;
    $[22] = t7;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  return t12;
};
function _temp(option) {
  return option.value === "variables";
}
export {
  VarHeadersStrip
};
//# sourceMappingURL=index.js.map
